<mat-tab-group class="overflow-auto">
  <mat-tab [label]="'communication.chat.members.allMembers' | t">
    <mat-list disableRipple>
      <mat-list-item
        *ngFor="let item of items; trackBy: trackBy"
        (click)="onItemTap(item)"
        (doubletap)="onItemDblTap(item)"
      >
        <div mat-line>
          <sn-user-status [status]="item.isOnline"></sn-user-status>
          <span class="itemFullName"> {{ item.fullName }}</span>
        </div>
        <div mat-line *ngIf="item.expirationTimestamp && item.isExternal" class="itemDetail">
          {{ 'common.expires' | t }}: {{ item.expirationTimestamp | fsFormatDate : 'medium' }}
        </div>
        <sn-icon-button
          *ngIf="actions?.length"
          [matMenuTriggerFor]="menu"
          [matMenuTriggerData]="{ item: item }"
          (click)="$event.stopPropagation()"
        >
          <sn-icon>more_vert</sn-icon>
        </sn-icon-button>
      </mat-list-item>
    </mat-list>
  </mat-tab>

  <mat-tab [label]="'communication.chat.members.onlineMembers' | t">
    <mat-list disableRipple>
      <mat-list-item
        *ngFor="let item of filterOnlineUsers(items); trackBy: trackBy"
        (click)="onItemTap(item)"
        (doubletap)="onItemDblTap(item)"
      >
        <div mat-line>
          <sn-user-status [status]="item.isOnline"></sn-user-status>
          <span class="itemFullName"> {{ item.fullName }}</span>
        </div>
        <div mat-line *ngIf="item.expirationTimestamp && item.isExternal" class="itemDetail">
          {{ 'common.expires' | t }}: {{ item.expirationTimestamp | fsFormatDate : 'medium' }}
        </div>
        <sn-icon-button
          *ngIf="actions?.length"
          [matMenuTriggerFor]="menu"
          [matMenuTriggerData]="{ item: item }"
          (click)="$event.stopPropagation()"
        >
          <sn-icon>more_vert</sn-icon>
        </sn-icon-button>
      </mat-list-item>
    </mat-list>
  </mat-tab>
</mat-tab-group>

<mat-menu #menu="matMenu" xPosition="before">
  <ng-template matMenuContent let-item="item">
    <sn-menu [items]="actions" [context]="item"></sn-menu>
  </ng-template>
</mat-menu>
